import clsx from 'clsx';
import * as React from 'react';

import { Card, type CardProps } from '@gitbook/spine-react';

export type InlineCardProps = Pick<CardProps, 'className' | 'children'> & {
    /**
     * Label for A11Y purpose.
     */
    label: string;
};

/**
 * Inline card used to display inline preview and edit form in popovers.
 */
export const InlineCard = React.forwardRef(function InlineCard(
    props: InlineCardProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <Card
            ref={ref}
            {...props}
            className={clsx(
                'w-screen max-w-72 whitespace-pre-wrap break-words px-3 py-2',
                props.className
            )}
            role="region"
            aria-label={props.label}
        />
    );
});
